import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';
import ConfirmDeleteModal from './ConfirmationModelDelete';

const BusinessDirectory = () => {
    const [userData, setUserData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [profileType, setProfileType] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const history = useHistory();
    const token = localStorage.getItem('authToken'); 
    const getData = async () => {
        try {
            const response = await axios.get(`https://samaj.aasmo.in/api/admin/businessdirectory?page=${currentPage}&profileType=${profileType}&username=${searchQuery}`,{
                headers: {
                    Authorization: `Bearer ${token}`, 
                  },
            });
            setUserData(response.data.data.users);
            setTotalPages(response.data.data.totalPages);
        } catch (error) {
            console.log(error);
        }
    };

    const handleEdit = (e, id) => {
        history.push(`/edit/${id}`);
    };

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`https://samaj.aasmo.in/api/admin/users/${id}`,{
                headers: {
                    Authorization: `Bearer ${token}`, 
                  },
            });
            if (response) {
                console.log("Deleted Successfully");
                getData();
            }
        } catch (error) {
            console.log(error);
        }
        setShowModal(false);
    };

    const handleDeleteClick = (id) => {
        setSelectedUserId(id);
        setShowModal(true);
    };

    useEffect(() => {
        getData();
    }, [currentPage, profileType, searchQuery]);

    const filteredUserData = userData.filter(user => {
        if (profileType === "all") return true;
        if (profileType === "business") return user.businessProfile && user.businessProfile.firmName.trim() !== '';
        if (profileType === "personal") return !user.businessProfile || user.businessProfile.firmName.trim() === '';
        return true;
    });

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleDownload = () => {
        const fields = [

            "numericId", "fullName", "contactNo", "bloodGroup", "bloodYN", "pincode", "address",
            "state", "city", "nativeOf", "homeDistrict", "homeCity", "caste", "subcaste",
            "gotra", "kuldeviName", "businessProfile.firmName", "businessProfile.firmAddress",
            "businessProfile.dealsWith", "email", "businessProfile.website",  "createdAt"
        ]
        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(filteredUserData);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'business_directory.csv');

    }

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="col-lg-12">
            <div className="card">
                <div className="header">
                    <h2>
                        Business Directory
                    </h2>
                </div>
                <div className="d-flex justify-content-start">
                    <div className="input-group m-b-10 col-lg-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text">
                                <i className="icon-magnifier"></i>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search By UserName"
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                    <div >
            <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
                </div>
                <div className="body table-responsive">
                    <table className="table table-hover">
                        <thead style={{textAlign:"center"}}>
                            <tr>
                                <th>Reg.ID</th>
                               
                                <th>Full Name</th>
                                <th>Contact No</th>
                                <th>Email</th>
                                <th>Blood Group</th>
                                <th>Blood Y/N</th>
                                <th>Pincode</th>
                                <th>Address</th>
                                <th>State</th>
                                <th>City</th>
                                <th>Native Of</th>
                                <th>Home District</th>
                                <th>Home City</th>
                                <th>Caste</th>
                                <th>Sub Caste</th>
                                <th>Gotra</th>
                                <th>Kuldevi/Kuldevta Name</th>
                                <th>Firm Name</th>
                                <th>Firm Address</th>
                                <th>Deal With</th>

                              
                                <th>Website</th>
                               
                                <th>Date</th>
                                {/* <th>Action</th> */}
                            </tr>
                        </thead>
                        <tbody style={{ textAlign: "center" }}>
                            {filteredUserData.map(user => (
                                <tr key={user._id}>
                                    <td>{user._id}</td>
                                    
                                    <td>{user.fullName}</td>
                                    <td>{user.contactNo}</td>
                                    <td>{user.email}</td>
                                    <td>{user.bloodGroup}</td>
                                    <td>{user.bloodYN}</td>
                                    <td>{user.pincode}</td>
                                    <td>{user.address}</td>
                                    <td>{user.state}</td>
                                    <td>{user.city}</td>
                                    <td>{user.nativeOf}</td>
                                    <td>{user.homeDistrict}</td>
                                    <td>{user.homeCity}</td>
                                    <td>{user.caste}</td>
                                    <td>{user.subcaste}</td>
                                    <td>{user.gotra}</td>
                                    <td>{user.kuldeviName}</td>
                                    <td>{user.businessProfile?.firmName}</td>
                                    <td>{user.businessProfile?.firmAddress}</td>
                                    <td>{user.businessProfile?.dealsWith}</td>

                                    
                                    <td>{user.businessProfile?.website}</td>

                                 
                                    <td> {formatDate(user.createdAt)}</td>

                                    {/* <td>
                                        <i className="icon-pencil" onClick={(e) => handleEdit(e, user?.numericId)}></i>
                                        &nbsp;&nbsp;
                                        <i className="fa fa-trash-o" onClick={() => handleDeleteClick(user?.numericId)}></i>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="body">
                    <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <NavLink
                                    to="#"
                                    className="page-link"
                                    onClick={() => handlePageChange(currentPage - 1)}
                                >
                                    Previous
                                </NavLink>
                            </li>
                            {[...Array(totalPages).keys()].map(page => (
                                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                                    <NavLink
                                        to="#"
                                        className="page-link"
                                        onClick={() => handlePageChange(page + 1)}
                                    >
                                        {page + 1}
                                    </NavLink>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                <NavLink
                                    to="#"
                                    className="page-link"
                                    onClick={() => handlePageChange(currentPage + 1)}
                                >
                                    Next
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <ConfirmDeleteModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleConfirm={() => handleDelete(selectedUserId)}
            />
        </div>
    );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(BusinessDirectory);
